module.exports = __webpack_public_path__ + "img/wenzi2.8753a474.webp";